import { render, staticRenderFns } from "./VenueDetails.vue?vue&type=template&id=5598be00&scoped=true"
import script from "./VenueDetails.vue?vue&type=script&lang=js"
export * from "./VenueDetails.vue?vue&type=script&lang=js"
import style0 from "./VenueDetails.vue?vue&type=style&index=0&id=5598be00&prod&lang=css"
import style1 from "./VenueDetails.vue?vue&type=style&index=1&id=5598be00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5598be00",
  null
  
)

export default component.exports